import { atom, selector } from "recoil";
import { geoStateDefaultSelector } from "../helpers";
import { GeoId } from "../types/geo.types";

export interface geoLevelProps {
    country: string;
    state?: string | null;
    district?: string | null;
    sub_district?: string | null;
}

export interface dropdownProps {
    geoId: GeoId;
    geoName: string;
    coverage?: string | null;
    count?: string | null;
}

export interface geoDataProps {
    dropDownData: dropdownProps[] | null;
    totalPoiCount?: any | null;
    totalCtvCount?: string | null;
    totalEhCount?: string | null;
    totalDistrictCoverage?: string | null;
    type: 'PoI' | 'CTV';
    geoId: GeoId;
    cat: { category: number[], subdistrict: number[] };
    currency: string;
}

export interface dropdownListProps {
    countries: geoDataProps,
    states: geoDataProps | null,
    districts: geoDataProps | null,
    sub_districts: geoDataProps | null,
    villages: geoDataProps | null,
}

export const geoState = atom({
    key: 'geoState',
    default: geoStateDefaultSelector,
});

export interface selectedGeoDropdownProps {
    geoId: GeoId;
    geoName: string;
    geoLevelNumber: number;
    geotype: string;
    ehpopcount?: string | null;
}

export const selectedGeoDropdownState = atom<selectedGeoDropdownProps>({
    key: 'selectedGeoDropdown',
    default: {
        geoId: 1,
        geoName: "India",
        geoLevelNumber: 1,
        geotype: "country",
    },
});

export const selectedGeoNameState = atom({
    key: 'selectedGeoName',
    default: 'India' as String,
});

export const dropdownList = atom({
    key: 'dropdownList',
    default: {
        countries: { dropDownData: [{ geoId: 1, geoName: "India" }] },
        states: null,
        districts: null,
        sub_districts: null,
        villages: null,
    } as dropdownListProps,
});

export const selectedTabState = atom<number>({
    key: "selectedTabState",
    default: Number(localStorage?.getItem("selectedTab")) || 4,
});